var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackgroundWavesHorizontal = function SvgBackgroundWavesHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 720",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0013 720C34.3996 698.28 31.1024 672.45 15.1097 653.614C-5.03656 629.887 -5.03657 595.06 15.1097 571.332C35.256 547.605 35.256 512.778 15.1097 489.05C-5.03655 465.323 -5.03658 430.496 15.1097 406.768C35.256 383.041 35.256 348.214 15.1097 324.486C-5.03657 300.759 -5.03655 265.932 15.1097 242.204C35.256 218.477 35.256 183.65 15.1097 159.922C-5.03657 136.195 -5.03656 101.368 15.1097 77.6404C33.9786 55.4171 35.175 23.4579 18.6989 0H74.76V720H25.0013Z"
  })));
};
export default SvgBackgroundWavesHorizontal;